const { registerBlockType } = window.wp.blocks;
const { useSelect } = wp.data;
const { Fragment } = wp.element;
const { InspectorControls, InnerBlocks } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;
const conditionalContentBlockName = 'crowdfavorite/conditional-content-block';

registerBlockType(conditionalContentBlockName, {
    title: 'Conditional Content Block',
    icon: 'table-row-after',
    category: 'common',
    keywords: [
		__( 'crowdfavorite', 'cf-conditional-content' ),
		__( 'conditional', 'cf-conditional-content' ),
    ],
    example: {},
    attributes: {
		condition: {
			type: 'array',
			default: [''],
		},
		conditionVisibility: {
			type: 'string',
			default: '',
		},
		conditionMatch: {
			type: 'string',
			default: '',
		},
    },
    edit(props) {
		// Available conditions
		let conditionsAvailable = [
			{
				label: __('None', 'cf-conditional-content'),
				value: '',
			}
		];

		Object.keys(CFCCGBAdminSettings.conditions).forEach(function (key) {
			conditionsAvailable.push({
				label: CFCCGBAdminSettings.conditions[key].label,
				value: CFCCGBAdminSettings.conditions[key].value
			});
		});

		const { condition } = props.attributes;
		const { conditionVisibility } = props.attributes;
		const { conditionMatch } = props.attributes;

		const hasInnerBlocks = useSelect(
			( select ) => {
				const { getBlock } = select( 'core/block-editor' );
				const block = getBlock( props.clientId );
				return !! ( block && block.innerBlocks.length );
			},
			[ props.clientId ]
		);

		const allowedBlocks = [];

		wp.blocks.getBlockTypes().forEach(( blockType ) => {
			if ( conditionalContentBlockName !== blockType.name ) {
				allowedBlocks.push(blockType.name);
			}
		});

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody
						title={ __('Conditional Content', 'cf-conditional-content') }
						initialOpen={ true }
					>
						<SelectControl
							label={ __('Visibility', 'cf-conditional-content') }
							value={ conditionVisibility }
							options={ [
								{
									label: __('Please select...', 'cf-conditional-content'),
									value: '',
									disabled: true
								},
								{
									label: __('Show when rules apply', 'cf-conditional-content'),
									value: 'yes'
								},
								{
									label: __('Hide when rules apply', 'cf-conditional-content'),
									value: 'no'
								}
							] }
							onChange={ (selectedVisibility) => {
								props.setAttributes( {
									conditionVisibility: selectedVisibility,
								} );
							} }
						/>
						<SelectControl
							label={ __('Should Match', 'cf-conditional-content') }
							value={ conditionMatch }
							options={ [
								{
									label: __('Please select...', 'cf-conditional-content'),
									value: '',
									disabled: true
								},
								{
									label: __('ALL rules', 'cf-conditional-content'),
									value: 'all'
								},
								{
									label: __('ANY rule', 'cf-conditional-content'),
									value: 'any'
								}
							] }
							onChange={ (selectedMatch) => {
								props.setAttributes( {
									conditionMatch: selectedMatch,
								} );
							} }
						/>
						<SelectControl
							label={ __('Applied Conditions', 'cf-conditional-content') }
							multiple={true}
							size="15"
							value={ condition }
							help={ __('Hold down ctrl/cmd to select multiple conditions', 'cf-conditional-content') }
							options={ conditionsAvailable }
							onChange={ (selectedCondition) => {
								if (-1 !== selectedCondition.indexOf('')) {
									props.setAttributes({condition: ['']});
								} else {
									props.setAttributes( {
										condition: selectedCondition,
									} );
								}
							} }
						/>
					</PanelBody>
				</InspectorControls>
				<div className={ props.className } >
					<InnerBlocks
						allowedBlocks={ allowedBlocks }

						renderAppender={
							hasInnerBlocks
							? undefined
							: () => <InnerBlocks.ButtonBlockAppender />
						}
					/>
				</div>
			</Fragment>
		);
    },
    save(props) {
		return (
			<div className={ props.className }>
				<InnerBlocks.Content />
			</div>
		);

    },
} );
